﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import Select from "react-select";

import { Row, Col, Form, Modal, Button } from "react-bootstrap";

import classes from "../../maintainers.module.scss";

import { hasPermission, toast, validRoles } from "@/services/Utils";
import api from "@/services/api.service";
import Fetching from "@/components/Fetching/Fetching";

import { customStyles } from "../operators.constants";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const OperatorsForm = ({ customers, estates_parents, estates, categories, confirmSave, permissions }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, slug } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [name, setName] = useState("");
	const [customer, setCustomer] = useState("");
	const [estateParent, setEstateParent] = useState([]);
	const [estate, setEstate] = useState([]);
	const [category, setCategory] = useState([]);

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.pathname.includes("configuracion")) {
			navigate("/configuracion/operadores");
			return;
		}

		if (location.pathname.includes("mantenedores")) {
			navigate("/mantenedores/operadores");
			return;
		}

		if (location.pathname.includes("mis_campos")) {
			navigate("/mis_campos");
			return;
		}
	};

	const validSave = () => {
		if (!name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!customer && location.pathname.includes("mantenedores")) {
			addToast("Debe seleccionar un cliente para guardar.", {
				appearance: "error",
			});

			return false;
		}

		return true;
	};

	const handleSave = () => {
		const form = {
			slug,
			name,
			estateParent,
			estate,
			category,
			customer,
		};

		if (validSave()) {
			confirmSave(form, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setName("");
		setCustomer("");
		setEstate([]);
		setCategory([]);
	};

	const afterSave = () => {
		handleClose();
		addToast("Operador guardado correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && slug) {
			api.get("/admin/operators/detail", { slug }).then((response) => {
				const { detail } = response;
				if (detail) {
					setName(detail.name ? detail.name : "");
					setCustomer(detail.customer_id ? detail.customer_id : "");
					setEstateParent(detail.estates_parents ? detail.estates_parents : []);
					setEstate(detail.estates ? detail.estates : []);
					setCategory(detail.categories ? detail.categories : []);
				} else {
					addToast("Ocurrió un problema al cargar el operador seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			if (estates_parents && estates_parents.length === 1) {
				setEstateParent([estates_parents[0].value]);
			}
			if (estates && estates.length === 1) {
				setEstate([estates[0].value]);
			}

			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [slug, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Operador</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>

								<Form.Control value={name} onChange={(e) => setName(e.currentTarget.value)} type="text" />
							</Form.Group>
						</Col>

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Campo</Form.Label>
								<Select
									isMulti
									value={
										estates_parents && estates_parents.filter((estate_parent) => estateParent && estateParent.includes(estate_parent.value))
									}
									placeholder={<div>Seleccione Campo</div>}
									options={estates_parents ? estates_parents : []}
									onChange={(value) => {
										let newEstatesParent = [];
										value &&
											value.map((estate_parent) => {
												newEstatesParent.push(estate_parent.value);
												return null;
											});

										setEstateParent(newEstatesParent);

										let availableEstates = estates.filter((e) => newEstatesParent.includes(e.estate_parent_id));

										setEstate(availableEstates.map((e) => e.value));
										setCategory([]);
									}}
									components={{
										NoOptionsMessage,
									}}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Bodega</Form.Label>
								<Select
									isMulti
									value={estates && estates.filter((et) => estate && estate.includes(et.value))}
									placeholder={<div>Seleccione Campo</div>}
									options={estates ? estates.filter((e) => estateParent.includes(e.estate_parent_id)) : []}
									onChange={(value) => {
										let newEstates = [];
										value &&
											value.map((estate) => {
												newEstates.push(estate.value);
												return null;
											});

										setEstate(newEstates);
										const validCategories = category.filter((catId) => {
											const cat = categories.find((c) => c.value === catId);
											return cat && cat.estate_ids && cat.estate_ids.some((eid) => newEstates.includes(eid));
										});
										setCategory(validCategories);
									}}
									components={{
										NoOptionsMessage,
									}}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>

						<Col md={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Categorías</Form.Label>
								<Select
									isMulti
									value={categories && categories.filter((et) => category && category.includes(et.value))}
									placeholder={<div>Seleccione Categoría</div>}
									options={categories ? categories.filter((c) => c.estate_ids && c.estate_ids.some((eid) => estate.includes(eid))) : []}
									onChange={(value) => {
										let newCategory = [];
										value &&
											value.map((category) => {
												newCategory.push(category.value);
												return null;
											});

										setCategory(newCategory);
									}}
									components={{
										NoOptionsMessage,
									}}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>

						{isAdmin && !location.pathname.includes("configuracion") && (
							<Col md={12} xs={12}>
								<Form.Group className={classes.group_form}>
									<Form.Label className={classes.label}>Cliente</Form.Label>

									<Select
										value={customers && customers.filter((c) => Number(c.value) === Number(customer))}
										placeholder={<div>Seleccione</div>}
										options={customers ? customers : []}
										onChange={(value) => setCustomer(value ? value.value : "")}
										components={{
											NoOptionsMessage,
										}}
										isClearable
									/>
								</Form.Group>
							</Col>
						)}
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{(slug ? hasPermission("edit", permissions) : hasPermission("create", permissions)) && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default OperatorsForm;
